import { Response, ResponseSubject, ResponseSubjectType, User } from "./types";

export function getUnique<T>(input: T[]): T[] {
  return Array.from(new Set<T>(input));
}

export function getCampaignProgress(responses: Response[]) {
  return {
    completed: responses.filter((r) => r.submitted).length,
    total: responses.length,
  };
}

export function getUserName(user: User) {
  if (!user) {
    return "[Course]";
  }
  return `${user.firstName} ${user.lastName}`;
}

export function sortedSubjects(
  subjectResponses: ResponseSubject[],
  authorId: string,
): ResponseSubject[] {
  return [...subjectResponses].sort((a, b) => {
    // Handle general (null id) subjects - always last
    if (
      a.subjectType === ResponseSubjectType.General ||
      a.subjectUserId === null
    )
      return 1;
    if (
      b.subjectType === ResponseSubjectType.General ||
      b.subjectUserId === null
    )
      return -1;

    // Author first
    if (a.subjectUserId === authorId) return -1;
    if (b.subjectUserId === authorId) return 1;

    // Deterministic sort by id for remaining subjects
    return a.subjectUserId.localeCompare(b.subjectUserId);
  });
}
